import { render, staticRenderFns } from "./settingGLAccounts.vue?vue&type=template&id=3201c99c&scoped=true&"
import script from "./settingGLAccounts.vue?vue&type=script&lang=js&"
export * from "./settingGLAccounts.vue?vue&type=script&lang=js&"
import style0 from "./settingGLAccounts.vue?vue&type=style&index=0&id=3201c99c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3201c99c",
  null
  
)

export default component.exports